import React from 'react';
import { Link } from './styled';
import { FormHeader } from './basic/FormHeader';
import { CengagePhoneHelp } from './basic/links/CengagePhoneHelp';

export const TEST_ID = {
  INSTRUCTIONS: 'error-instructions'
};

interface SheerErrorContentProps {
  msg?: string | React.ReactNode;
}

export const SheerErrorContent: React.FunctionComponent<SheerErrorContentProps> = (
  props: SheerErrorContentProps
) => {
  const { msg = 'There was an unexpected error.' } = props;

  return (
    <React.Fragment>
      <FormHeader>Sorry!</FormHeader>
      <div
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          textAlign: 'center'
        }}
        data-testid={TEST_ID.INSTRUCTIONS}
      >
        <p>{msg} </p>
        <p>Please <CengagePhoneHelp /></p>
        <p><Link href="/">Return to homepage</Link></p>
      </div>
    </React.Fragment>
  );
};
